module.exports = __webpack_public_path__ + "static/img/14000519.9946564c.png";